import React from 'react';
import parse from 'html-react-parser';
import { sanitizeTitle } from '@/libs/sanitizeTitle/sanitizeTitle';
interface AssetMetadataProps {
  docType: string;
  publishDate: string;
  title: string;
}
const AssetMetadata: React.FC<AssetMetadataProps> = ({
  docType,
  publishDate,
  title
}) => {
  return <>
      <p className={'asset-meta'}>
        <span className={'asset-type'}>{docType}</span>
        <span className={'divider-line'}>|</span>
        <span className={'published-date'}>{publishDate}</span>
      </p>
      <h1 className={'asset-title'}>
        {parse(sanitizeTitle(title))}
      </h1>
    </>;
};
export default AssetMetadata;